import React from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  trans,
  getResourcePath,
  useSoyuzLocales
} from '@spotahome/soyuz/client';
import LazyLoad from 'react-lazyload';

import TextBlock from '../../../common/components/TextBlock';

import './ShowcaseBookingRequestSection.scss';

const MQ_MOBILE_MAX_WIDTH = 767;

const langVideoAvailableList = ['en', 'es', 'pt', 'it', 'fr', 'de'];

const ShowcaseBookingRequestSection = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${MQ_MOBILE_MAX_WIDTH}px)`
  });
  const { current } = useSoyuzLocales();

  const getVideoLanguage = () => {
    if (langVideoAvailableList.indexOf(current) > -1) {
      return current;
    }
    return 'en';
  };

  return (
    <section className="showcase-booking-request-section">
      <div className="showcase-booking-request-section__wrapper">
        <LazyLoad height={100} offset={[100, 100]} once>
          <video
            loop
            autoPlay
            playsInline
            muted
            preload="true"
            className="showcase-booking-request-section__image"
          >
            <source
              src={getResourcePath(
                `/videos/landlord-accept-reject-br-[${getVideoLanguage()}].mp4`
              )}
            />
          </video>
        </LazyLoad>
        <div className="showcase-booking-request-section__text">
          <TextBlock
            title={trans('Lister.landing.page-no.phone.calls.title')}
            content={trans('Lister.landing.page-no.phone.calls.body')}
            alignTo={isMobile ? 'center' : 'left'}
            titleSize="big"
            titleTag="h2"
          />
        </div>
      </div>
    </section>
  );
};

export default ShowcaseBookingRequestSection;
